<template>
  <div
    class="wf-border wf-border-transparent hover:wf-border-blue-500 wf-p-2 wf-w-full wf-relative"
    :class="containerClasses" :style="elementStyles(styles('styles'))"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="header"
      v-show="hover && ! previewMode"
      :options="menuOptions"
    />
    <div class="wf-hidden sm:wf-block" v-show="device != 'phone'">
      <component
        :is="selectedHeaderType"
        :logo="content.logo"
        :nav-links="content.navLinks"
        :has-cta="content.hasCTA"
        :mega-menu-full-width="content.megaMenuFullWidth"
        :cta-text="content.ctaText"
        :classes="elementClasses(classes('classes'))"
        :ctaClasses="elementClasses(classes('ctaClasses'))"
        :ctaStyles="elementStyles(styles('ctaStyles'))"
        :containerNavLinkClasses="elementClasses(classes('containerNavLinkClasses'))"
        :navLinkClasses="elementClasses(classes('navLinkClasses'))"
        :navLinkStyles="elementStyles(styles('navLinkStyles'))"
        :subMenuClasses="elementClasses(classes('subMenuClasses'))"
        :subMenuStyles="elementStyles(styles('subMenuStyles'))"
        :subMenuContainerClasses="elementClasses(classes('subMenuContainerClasses'))"
        :subMenuContainerStyles="elementStyles(styles('subMenuContainerStyles'))"
        :megaMenuClasses="elementClasses(classes('megaMenuClasses'))"
        :megaMenuStyles="elementStyles(styles('megaMenuStyles'))"
        :megaMenuContainerClasses="elementClasses(classes('megaMenuContainerClasses'))"
        :megaMenuContainerStyles="elementStyles(styles('megaMenuContainerStyles'))"
        :megaMenuTitleClasses="elementClasses(classes('megaMenuTitleClasses'))"
        :megaMenuTitleStyles="elementStyles(styles('megaMenuTitleStyles'))"
      />
    </div>
    <div class="wf-block sm:wf-hidden" v-show="device == 'phone'">
      <HeaderHamburger
        :logo="content.logo"
        :nav-links="content.navLinks"
        :has-cta="content.hasCTA"
        :mega-menu-full-width="content.megaMenuFullWidth"
        :cta-text="content.ctaText"
        :classes="elementClasses(classes('classes'))"
        :ctaClasses="elementClasses(classes('ctaClasses'))"
        :ctaStyles="elementStyles(styles('ctaStyles'))"
        :containerNavLinkClasses="elementClasses(classes('containerNavLinkClasses'))"
        :navLinkClasses="elementClasses(classes('navLinkClasses'))"
        :navLinkStyles="elementStyles(styles('navLinkStyles'))"
        :subMenuClasses="elementClasses(classes('subMenuClasses'))"
        :subMenuStyles="elementStyles(styles('subMenuStyles'))"
        :megaMenuClasses="elementClasses(classes('megaMenuClasses'))"
        :megaMenuStyles="elementStyles(styles('megaMenuStyles'))"
        :megaMenuContainerClasses="elementClasses(classes('megaMenuContainerClasses'))"
        :megaMenuContainerStyles="elementStyles(styles('megaMenuContainerStyles'))"
        :megaMenuTitleClasses="elementClasses(classes('megaMenuTitleClasses'))"
        :megaMenuTitleStyles="elementStyles(styles('megaMenuTitleStyles'))"
      />
    </div>
  </div>
</template>

<script>
  import HeaderLeft from './HeaderLeft'
  import HeaderSplit from './HeaderSplit'
  import HeaderCenter from './HeaderCenter'
  import HeaderDefault from './HeaderDefault' 
  import HeaderHamburger from './HeaderHamburger'
  import {StylesParser} from '../../StylesParser'
  import {ConstantsParser} from '../../ConstantsParser'
  export default {
    components : {
      HeaderLeft,
      HeaderSplit,
      HeaderCenter,
      HeaderDefault,
      HeaderHamburger,
    },
    data() {
      return {
        hover: false,
        width: window.innerWidth
      }
    },

    mounted() {
      window.addEventListener('resize', () => this.width = window.innerWidth)
    },
    computed: {
      containerClasses() {
        let classes = this.classes('containerClasses')
        if(! this.previewMode) {
          classes = this.classes('containerClasses')[this.device].filter(elementClass => elementClass.property != 'Fixed')
        }
        return this.elementClasses(classes)
      },
      selectedHeaderType() {
        return ({
          DEFAULT: 'HeaderDefault',
          CENTER: 'HeaderCenter',
          SPLIT: 'HeaderSplit',
          LEFT: 'HeaderLeft',
          HAMBURGER: 'HeaderHamburger'
        })[this.content.type]
      },
      device() {
        let device = this.$store.getters['pageModule/device']
        if (this.width < 640 || device == 'phone') {
          return 'phone'
        }
        if (this.width < 768 || device == 'tablet') {
          return 'tablet'
        }
        return 'desktop'
      },
      module() {
        return 'headerModule'
      },
      element() {
        return {
          header: 0
        }
      },
      previewMode() {
        return this.$store.state.previewMode
      },
      menuOptions() {
        return [
          {
            name: 'settings',
            icon: 'fa-cog',
            hoverable: true,
            method: 'openMenu',
            classes: [],
            menu: 'HeaderMenu',
          }
        ]
      },
      content() {
        return this.$store.getters[`${this.module}/content`](this.element)
      },
    },
    methods: {
      classes(classes) {
        return this.$store.getters[`${this.module}/classes`](this.element, classes)
      },
      elementClasses(classes) {
        return (new ConstantsParser(classes, Array.isArray(classes) ? null : this.device)).parse()
      },
      styles(styles) {
      return this.$store.getters[`${this.module}/styles`](this.element, styles)
    },
    elementStyles(styles) {
      return (new StylesParser(styles, this.device)).parse()
    },
    }
  }
</script>